import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { ExaminationRoutingModule } from './examination-routing.module';
import { WorkprocessModule } from './workprocess/workprocess.module';
import { ExaminationComponent } from './examination/examination.component';
import { StepsComponent } from './steps/steps.component';
import { DataCheckComponent } from './data-check/data-check.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatButtonModule } from '@angular/material';
import { ResultComponent } from './result/result.component';
import { StudentSigningComponent } from './student-signing/student-signing.component';
import { FirstAssessorSigningComponent } from './first-assessor-signing/first-assessor-signing.component';
import { SecondAssessorSigningComponent } from './second-assessor-signing/second-assessor-signing.component';
import { SignaturePadModule } from 'angular2-signaturepad';
import { SummaryComponent } from './summary/summary.component';
import { CoreTaskDataService } from './core-task-data.service';
import { SemsoSnackbarService } from '../semso-snackbar.service';
import { CoreTaskService } from './core-task.service';
import { BreadcrumbModule } from '../breadcrumb/breadcrumb.module';
import { SemsoPdfViewerModule } from '../semso-pdf-viewer/semso-pdf-viewer.module';
import { DialogService } from '../services/dialog.service';

@NgModule({
  imports: [
    CommonModule,
    ExaminationRoutingModule,
    WorkprocessModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    SignaturePadModule,
    BreadcrumbModule,
    SemsoPdfViewerModule
  ],
  declarations: [ExaminationComponent, StepsComponent, DataCheckComponent,
    ResultComponent, StudentSigningComponent, FirstAssessorSigningComponent, SecondAssessorSigningComponent, SummaryComponent],
  providers: [CoreTaskDataService, SemsoSnackbarService, CoreTaskService, DialogService],
})
export class ExaminationModule { }



// WEBPACK FOOTER //
// ./src/app/examination/examination.module.ts